const activeClass = 'nav-main-active'
const nav = document.querySelector('.nav-main-wrap')
const toggle = document.querySelector('.hd-nav-toggle')

let active = false

if (nav && toggle) {
	toggle.addEventListener('click', () => {
		active = !active
		nav.classList[active ? 'add' : 'remove'](activeClass)
		toggle.classList[active ? 'add' : 'remove'](activeClass)
	})
}
